// src/lib/opportunity/formatCalcLineTypes.ts
//
// Shared types for manager-defined format calculation lines (7a).
// Imported from browser + server — use relative paths from server code.

import type { OpportunityFormatKey } from "../../types/opportunity.js";

/** Wildcard product_type — org-wide generic template. */
export const FORMAT_CALC_PRODUCT_TYPE_WILDCARD = "*";

export const FORMAT_CALC_PLACEMENTS = ["before_subtotal", "after_subtotal"] as const;
export type FormatCalcPlacement = (typeof FORMAT_CALC_PLACEMENTS)[number];

export const FORMAT_CALC_PLACEMENT_LABELS: Record<FormatCalcPlacement, string> = {
  before_subtotal: "Before subtotal",
  after_subtotal: "After subtotal",
};

export const FORMAT_CALC_AMOUNT_MODES = ["fixed", "percent"] as const;
export type FormatCalcAmountMode = (typeof FORMAT_CALC_AMOUNT_MODES)[number];

export const FORMAT_CALC_LABEL_MAX_LEN = 120;

/** Row shape from `opp_format_calc_lines`. */
export type FormatCalcLine = {
  id: string;
  organization_id: string;
  format_key: OpportunityFormatKey;
  product_type: string;
  placement: FormatCalcPlacement;
  sort_order: number;
  label: string;
  amount_mode: FormatCalcAmountMode;
  default_amount: number;
  visible_on_proposal: boolean;
  commissionable: boolean;
  include_in_deposit: boolean;
  updated_by_user_id: string | null;
  created_at: string;
  updated_at: string;
};

/** Minimal line def for pure evaluation (no DB metadata). */
export type FormatCalcLineDef = Pick<
  FormatCalcLine,
  | "id"
  | "placement"
  | "sort_order"
  | "label"
  | "amount_mode"
  | "default_amount"
  | "visible_on_proposal"
  | "commissionable"
  | "include_in_deposit"
>;

/** Product-specific calc lines win; otherwise use the org `*` template. */
export function selectFormatCalcLines(args: {
  specificLines: FormatCalcLine[];
  wildcardLines: FormatCalcLine[];
}): FormatCalcLine[] {
  return args.specificLines.length > 0 ? args.specificLines : args.wildcardLines;
}
